// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__VEyQQ","top-section":"footer_top-section__ICfm2","service":"footer_service__0XBdt","bottom-section":"footer_bottom-section__r_Gfh"};